import React from "react";
import { Col, Row, Button, Typography, List, Collapse } from "antd";

import { useSelector } from "react-redux";
//components

import { branchDetailBySlugSelector } from "../../../../store/branch/branch.selector";
import BranchBooking from "./component/branch_booking";
import BranchGettimely from "./component/branch_gettimely";

const { Title } = Typography;

const BranchBanner = ({ mobile, tablet }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderSummaryStore = () => {
    return (
      <div style={{ fontSize: mobile ? "small" : "16px" }}>
        <Title className="branch-title" level={6} style={{ marginBottom: 30 }}>
          BOOKING
        </Title>
        {/* <div className="location-list">
          <div className="align-end">
            <BranchBooking />
          </div>
          <div className="align-start">
            <BranchGettimely />
          </div>
        </div> */}
        <Row gutter={[4, 12]}>
          <Col
            xs={0}
            sm={0}
            lg={2}
            xl={2}
            style={{ display: "flex", justifyContent: "center" }}
          ></Col>
          <Col
            xs={11}
            sm={11}
            lg={9}
            xl={9}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <div style={{ width: "auto" }}>
              <BranchBooking mobile={mobile} tablet={tablet} />
            </div>
          </Col>
          <Col
            xs={1}
            sm={1}
            lg={1}
            xl={1}
            style={{ display: "flex", justifyContent: "center" }}
          ></Col>
          <Col
            xs={11}
            sm={11}
            lg={9}
            xl={9}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <div style={{ width: "auto" }}>
              <BranchGettimely mobile={mobile} tablet={tablet} />
            </div>
          </Col>
          <Col
            xs={0}
            sm={0}
            lg={2}
            xl={2}
            style={{ display: "flex", justifyContent: "center" }}
          ></Col>
        </Row>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
      <Row className="branch-banner" gutter={[0, 20]}>
        <Col
          className="booking-info"
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          xxl={24}
        >
          {renderSummaryStore()}
        </Col>
        {/* <Button onClick={handleClick}>Test</Button> */}
      </Row>
    </Col>
  );
};

export default BranchBanner;
